import { connect } from 'react-redux';
import { fetchUserModelAction } from '@helpcenter/epics-models/src/user';
import Header from './header';

export default connect(null, {
    fetchUser: fetchUserModelAction,
})(Header);
